/**
 * Creado por Norte70
 *
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 29/09/2020  
 */
const registerRequestModel = () => {
    return {
        tipo_persona: '',
        user_type: '',
        usuario: '',
        email:'',
        telefono:'',
        password: '',
        password_confirm: '',
        confirmado: '',

        client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID,

        curp: '',
        nombres: '',
        apellido_paterno: '',
        apellido_materno: '',
        rfc: '',

      /*  estado: '',
        municipio: '',
        colonia: '',
        calle: '',
        num_ext: '',
        num_int: '',
        cp: '',
        lat: '',
        lng: ''*/
    }
}

export default registerRequestModel;